/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import HomeIcon from '@material-ui/icons/HomeOutlined';
import CardsIcon from '@material-ui/icons/FolderOpenOutlined';
import ProfileIcon from '@material-ui/icons/Person';

const navConfig = [
  {
    items: [
      {
        title: 'ניהול כרטיס',
        href: '/admin/dashboard',
        icon: HomeIcon,
      },
      {
        title: 'עריכת כרטיס',
        href: '/admin/dashboard/edit',
        icon: CardsIcon,
      },
      { title: 'פרופיל', href: '/admin/profile', icon: ProfileIcon },
      { title: 'תקנון שימוש', href: '/terms-of-service' },
    ],
  },
];

export default navConfig;
